// extracted by mini-css-extract-plugin
export default {"navBox":"MobileMenu_navBox__XLP99","mobileNav":"MobileMenu_mobileNav__L6tZf","navLink":"MobileMenu_navLink__L8RW0"};